import React, { Component } from 'react'
import axios from 'axios'
import MaskedInput from 'react-text-mask'
import PropTypes from 'prop-types'
import LoadingImage from '../LoadingImage'
import { URL_API } from '../../actions/urls'

export default class Cep extends Component {
    constructor() {
        super();
        let anyNum = /[0-9]/
        this.state = { 
            value: null,
            loading: false,
            mask: [anyNum, anyNum, anyNum, anyNum, anyNum, '-', anyNum, anyNum, anyNum]
        }

        this.buscaCep = this.buscaCep.bind(this)
    }

    buscaCep = (cep) => {
        cep = cep.replace(/[^0-9]/g, '')
        if(cep?.length !== 8 || !this.props.mounted) return
        this.setState({
            loading: true
        })
        axios.get(URL_API+'cep?cep='+cep)
        .then(res => {
            if(this.props.mounted){
                this.setState({
                    loading: false
                })
                if(this.props.callback)
                    this.props.callback(res.data)
            }
        })
        .catch(err => {
            this.setState({
                loading: false
            })
            let erro = {message: "Não foi possível obter os dados do CEP"}
            if(err.response){
                erro = err.response.data
            }
            console.error(erro.message)
        });
    }

    onChange = (event) => {
        var value = event.target.value
        this.setState({
            value: value
        })
        this.buscaCep(value)
        this.props.onChange(event)
    }
      
    render() {
        const value = this.state.value === null ? this.props.value : this.state.value
        let props = {}
        Object.keys(this.props).map((idx)=>{ // Não pode colocar a função customizada callback no input
            if(idx !== 'callback' && idx !== 'mounted') 
                props[idx] = this.props[idx]
            
            return null
        })
        return (
            <div>
                <MaskedInput guide={false} type="tel" mask={this.state.mask} {...props} value={value} onKeyUp={this.onChange} className="form-control" />
                {this.state.loading &&
                    <LoadingImage absolute="true" style={{
                        position: 'absolute',
                        right: '21px',
                        width: '30px',
                        bottom: '23%',
                    }}></LoadingImage>
                }
            </div>
        )
    }
}
Cep.propTypes = {
    mounted: PropTypes.bool.isRequired,
}